import { GeneralService, ApiKeyOrGetter } from "./GeneralService";

export interface BaseModelCandidate {
  id: number;
  hf_model_id: string;
  display_name: string | null;
  status: string;
  inferred_family: string | null;
  response_start_token: string | null;
  response_end_token: string | null;
  chat_template_format: string | null;
  text_only: boolean | null;
  default_rank: number | null;
  default_alpha: number | null;
  force_fourbit: boolean | null;
  deployment_config: Record<string, unknown> | null;
  notes: Record<string, unknown> | null;
  date_created: number;
  date_updated: number;
}

export class BaseModelCandidateService {
  public static listCandidates(
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter,
    status?: string,
    search?: string,
    limit?: number,
    offset?: number
  ) {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    if (search?.trim()) params.set("search", search.trim());
    if (limit != null) params.set("limit", String(limit));
    if (offset != null) params.set("offset", String(offset));
    const path = params.toString()
      ? `/admin/base_model_candidate/candidates?${params}`
      : "/admin/base_model_candidate/candidates";
    return GeneralService.get(
      path,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static createCandidate(
    hfModelId: string,
    displayName: string | null,
    skipDiscovery: boolean,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      "/admin/base_model_candidate/candidates",
      JSON.stringify({
        hf_model_id: hfModelId,
        display_name: displayName || undefined,
        skip_discovery: skipDiscovery,
      }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static discover(
    candidateId: number,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/admin/base_model_candidate/candidates/${candidateId}/discover`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static promote(
    candidateId: number,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/admin/base_model_candidate/candidates/${candidateId}/promote`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
